(() => {
  const fans = document.querySelectorAll('[data-certificate-fan]');

  fans.forEach((fan) => {
    const deck = fan.querySelector('[data-certificate-deck]');
    const items = Array.from(fan.querySelectorAll('[data-certificate-item]'));
    const navButtons = Array.from(fan.querySelectorAll('[data-certificate-nav]'));
    const activeTitle = fan.querySelector('[data-certificate-active-title]');
    const activeDescription = fan.querySelector('[data-certificate-active-description]');
    const counter = fan.querySelector('[data-certificate-counter]');
    const dialog = fan.querySelector('[data-certificate-dialog]');
    const dialogImage = fan.querySelector('[data-certificate-dialog-image]');
    const dialogTitle = fan.querySelector('[data-certificate-dialog-title]');
    const dialogDescription = fan.querySelector('[data-certificate-dialog-description]');
    const mobileQuery = window.matchMedia('(max-width: 48rem)');

    if (!deck || !items.length) return;

    let activeIndex = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
    let scrollFrame = null;

    const getCopy = (item) => {
      const caption = item.querySelector('figcaption');
      return {
        title: caption?.querySelector('strong')?.textContent?.trim() || '',
        description: caption?.querySelector('span')?.textContent?.trim() || '',
        summary: item.dataset.certificateSummary || caption?.querySelector('span')?.textContent?.trim() || '',
      };
    };

    const updateLayout = () => {
      const offsets = [-.43, -.30, -.17, 0, .16, .28, .37, .43];
      const baseScale = [.76, .84, .92, 1, .94, .86, .79, .72];
      const vertical = [22, 15, 7, 0, 6, 14, 20, 25];
      const rotation = [-3.2, -2.35, -1.2, 0, 1.1, 2.1, 2.9, 3.7];

      items.forEach((item, index) => {
        const active = index === activeIndex;
        item.style.setProperty('--fan-x', `${deck.clientWidth * offsets[index]}px`);
        item.style.setProperty('--fan-y', `${active ? -7 : vertical[index]}px`);
        item.style.setProperty('--fan-scale', String(baseScale[index] * (active ? 1.075 : 1)));
        item.style.setProperty('--fan-rotate', `${active ? 0 : rotation[index]}deg`);
        item.style.setProperty('--fan-z', String(active ? 20 : index < 4 ? index + 3 : 12 - index));
      });
    };

    const activate = (nextIndex, options = {}) => {
      const normalizedIndex = (nextIndex + items.length) % items.length;
      activeIndex = normalizedIndex;

      items.forEach((item, index) => {
        const active = index === activeIndex;
        item.classList.toggle('is-active', active);
        item.querySelector('[data-certificate-trigger]')?.setAttribute('aria-pressed', String(active));
      });

      navButtons.forEach((button, index) => {
        const active = index === activeIndex;
        button.classList.toggle('is-active', active);
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });

      const copy = getCopy(items[activeIndex]);
      if (activeTitle) activeTitle.textContent = copy.title;
      if (activeDescription) activeDescription.textContent = copy.summary;
      if (counter) counter.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
      fan.style.setProperty('--certificate-progress', `${(activeIndex / Math.max(1, items.length - 1)) * 100}%`);

      updateLayout();

      if (options.focus) items[activeIndex].querySelector('[data-certificate-trigger]')?.focus();
      if (options.scroll && mobileQuery.matches) {
        const activeItem = items[activeIndex];
        const activeNav = navButtons[activeIndex];
        const navTrack = activeNav?.parentElement;
        const behavior = options.instant ? 'auto' : 'smooth';

        deck.scrollTo({
          left: activeItem.offsetLeft - (deck.clientWidth - activeItem.offsetWidth) / 2,
          behavior,
        });
        navTrack?.scrollTo({
          left: activeNav.offsetLeft - (navTrack.clientWidth - activeNav.offsetWidth) / 2,
          behavior,
        });
      }
    };

    const openPreview = (item) => {
      if (!dialog) return;
      const image = item.querySelector('img');
      const copy = getCopy(item);

      if (dialogImage && image) {
        dialogImage.src = image.currentSrc || image.src;
        dialogImage.alt = image.alt;
      }
      if (dialogTitle) dialogTitle.textContent = copy.title;
      if (dialogDescription) dialogDescription.textContent = copy.description;

      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    };

    items.forEach((item, index) => {
      const trigger = item.querySelector('[data-certificate-trigger]');
      if (!trigger) return;

      item.addEventListener('mouseenter', () => {
        if (!mobileQuery.matches) activate(index);
      });

      trigger.addEventListener('focus', () => activate(index));
      trigger.addEventListener('click', () => {
        activate(index, { scroll: true });
        openPreview(item);
      });

      trigger.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = activeIndex;
        if (event.key === 'ArrowLeft') nextIndex -= 1;
        if (event.key === 'ArrowRight') nextIndex += 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = items.length - 1;
        activate(nextIndex, { focus: true, scroll: true });
      });
    });

    navButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activate(Number(button.dataset.certificateNav), { scroll: true });
      });
    });

    deck.addEventListener('scroll', () => {
      if (!mobileQuery.matches || scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        const deckCenter = deck.getBoundingClientRect().left + deck.clientWidth / 2;
        let closestIndex = activeIndex;
        let closestDistance = Number.POSITIVE_INFINITY;

        items.forEach((item, index) => {
          const rect = item.getBoundingClientRect();
          const itemCenter = rect.left + rect.width / 2;
          const distance = Math.abs(deckCenter - itemCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== activeIndex) activate(closestIndex);
        scrollFrame = null;
      });
    }, { passive: true });

    if (dialog) {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.querySelector('[data-open-rfq]')?.addEventListener('click', () => dialog.close());
    }

    window.addEventListener('resize', updateLayout, { passive: true });
    mobileQuery.addEventListener?.('change', () => activate(activeIndex, { scroll: mobileQuery.matches }));
    activate(activeIndex, { scroll: mobileQuery.matches, instant: true });
  });
})();
